import * as Api from '@Api/index';

import type { Query } from '@Types/Base';

interface Params {
  url: string;
  request?: Query;
}

interface Response<T> {
  body: {
    data: T;
  };
  page: string;
}

async function fetchPage<T>(params: Params): Promise<T> {
  const url = `/backend${params.url}`;

  const res = await Api.queryProxi<Response<T>>(
    url,
    { headers: { 'X-Request-Type': 'page' } },
    params.request,
  );

  return { ...res.body?.data, page: res.page };
}

export default fetchPage;
